import { render, staticRenderFns } from "./bulkCargoDetailsIndex.vue?vue&type=template&id=7edc1b8a&"
import script from "./bulkCargoDetailsIndex.vue?vue&type=script&lang=js&"
export * from "./bulkCargoDetailsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports